import * as React from "react";
import { useMemo } from "react";
import { Provider } from "react-redux";
import * as Immutable from "immutable";
import usePluginEntities from "hooks/usePluginEntities";
import createStore from "store";
import useSearchExecutors from "views/components/contexts/useSearchExecutors";
const useActiveQuery = (initialQuery, view) => {
  var _a;
  return useMemo(() => {
    var _a2, _b, _c;
    const queries = (_b = (_a2 = view == null ? void 0 : view.search) == null ? void 0 : _a2.queries) != null ? _b : Immutable.Set();
    if (initialQuery && queries.find((q) => q.id === initialQuery) !== void 0) {
      return initialQuery;
    }
    return (_c = queries.first()) == null ? void 0 : _c.id;
  }, [initialQuery, (_a = view == null ? void 0 : view.search) == null ? void 0 : _a.queries]);
};
const useInitialState = (undoRedoState, view, isNew, activeQuery, executionState, result) => useMemo(
  () => {
    const undoRedo = undoRedoState ? { undoRedo: undoRedoState } : {};
    return {
      view: {
        view,
        isDirty: false,
        isNew,
        activeQuery
      },
      searchExecution: {
        searchTypesToSearch: void 0,
        executionState,
        isLoading: false,
        result
      },
      ...undoRedo
    };
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [executionState, isNew, view]
);
const ViewsStoreProvider = ({
  initialQuery,
  children = void 0,
  isNew,
  view,
  executionState,
  undoRedoState = void 0,
  result = void 0
}) => {
  const reducers = usePluginEntities("views.reducers");
  const activeQuery = useActiveQuery(initialQuery, view);
  const initialState = useInitialState(undoRedoState, view, isNew, activeQuery, executionState, result);
  const searchExecutors = useSearchExecutors();
  const store = useMemo(
    () => createStore(reducers, initialState, { searchExecutors }),
    [initialState, reducers, searchExecutors]
  );
  return /* @__PURE__ */ React.createElement(Provider, { store }, children);
};
export default ViewsStoreProvider;
